import { all, takeEvery } from 'redux-saga/effects';
import { handleEditEntry } from './workers/handleEditEntry';
import actions from './actions';

export default function* rootSaga() {
  yield all([
    takeEvery(actions.SET_EDIT_ENTRY, handleEditEntry),
  ]);
}
